module.exports = __webpack_public_path__ + "img/gou.e5ebd825.png";